var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBySideLightDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 54,
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3427_325153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H47.5V53.5H2C1.17157 53.5 0.5 52.8284 0.5 52V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5C25.6406 27.5 27 26.1641 27 24.5C27 22.8594 25.6406 21.5 24 21.5C22.3359 21.5 21 22.8594 21 24.5C21 26.1641 22.3359 27.5 24 27.5ZM26.0859 28.25H25.6875C25.1719 28.5078 24.6094 28.625 24 28.625C23.3906 28.625 22.8047 28.5078 22.2891 28.25H21.8906C20.1562 28.25 18.75 29.6797 18.75 31.4141V32.375C18.75 33.0078 19.2422 33.5 19.875 33.5H28.125C28.7344 33.5 29.25 33.0078 29.25 32.375V31.4141C29.25 29.6797 27.8203 28.25 26.0859 28.25Z",
    fill: "#5C617C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H47.5V53.5H2C1.17157 53.5 0.5 52.8284 0.5 52V2Z",
    stroke: "#6E7391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 0.5H94C94.8284 0.5 95.5 1.17157 95.5 2V52C95.5 52.8284 94.8284 53.5 94 53.5H48.5V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 27.5C73.6406 27.5 75 26.1641 75 24.5C75 22.8594 73.6406 21.5 72 21.5C70.3359 21.5 69 22.8594 69 24.5C69 26.1641 70.3359 27.5 72 27.5ZM74.0859 28.25H73.6875C73.1719 28.5078 72.6094 28.625 72 28.625C71.3906 28.625 70.8047 28.5078 70.2891 28.25H69.8906C68.1562 28.25 66.75 29.6797 66.75 31.4141V32.375C66.75 33.0078 67.2422 33.5 67.875 33.5H76.125C76.7344 33.5 77.25 33.0078 77.25 32.375V31.4141C77.25 29.6797 75.8203 28.25 74.0859 28.25Z",
    fill: "#5C617C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 0.5H94C94.8284 0.5 95.5 1.17157 95.5 2V52C95.5 52.8284 94.8284 53.5 94 53.5H48.5V0.5Z",
    stroke: "#6E7391"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_325153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBySideLightDefault);
export default __webpack_public_path__ + "static/media/side-by-side-light-default.f5e578669.svg";
export { ForwardRef as ReactComponent };